//希腊语
export default {
    今日涨跌:"Αλλαγή σήμερα",
    商品:"Εμπορεύματα",
    交割:"Διανομή",
关于我们:"σχετικά με εμάς",
账变记录:"Αρχεία αλλαγής λογαριασμού",
股票:"στοκ",
加密货币:"κρυπτονόμισμα",
加载中:"φόρτωση...",
已经全部加载完毕:"Όλα έχουν φορτωθεί",
暂无记录:"Κανένα αρχείο",
高级认证:"Προηγμένη πιστοποίηση",
姓名:"Ονομα",
请输入姓名:"Παρακαλώ πληκτρολογήστε το όνομά σας",
护照编号:"Αριθμός διαβατηρίου",
请输入护照编号:"Εισαγάγετε τον αριθμό διαβατηρίου",
护照照片:"Φωτογραφία διαβατηρίου",
申请认证:"Κάντε αίτηση για πιστοποίηση",
提示:"ίχνος",
 全球领先的期货和数字资产平台: "Παγκόσμια ηγετική πλατφόρμα συμβολαίων μελλοντικής εκπλήρωσης και ψηφιακών περιουσιακών στοιχείων",
确定:"Σίγουρος",
提交失败:"Η υποβολή απέτυχε",
上传失败:"Η μεταφόρτωση απέτυχε",
身份认证:"Αυθεντικοποίηση",
身份证号:"αριθμό ταυτότητας",
请输入身份证号:"Εισαγάγετε τον αριθμό αναγνώρισης",
身份证照片:"Φωτογραφία ταυτότητας",
申请认证:"Κάντε αίτηση για πιστοποίηση",
修改资金密码:"Αλλαγή κωδικού πρόσβασης ταμείου",
旧密码:"ΠΑΛΙΟΣ ΚΩΔΙΚΟΣ",
请输入旧密码:"Εισαγάγετε τον παλιό κωδικό πρόσβασης",
新密码:"Νέος Κωδικός",
请输入6位数字:"Εισαγάγετε 6 ψηφία",
确认新密码:"Επιβεβαιώστε τον νέο κωδικό πρόσβασης",
请再次输入新密码:"Εισαγάγετε ξανά νέο κωδικό πρόσβασης",
提交:"υποβάλλουν",
请输入新密码:"Εισαγάγετε έναν νέο κωδικό πρόσβασης",
请输入6位数新密码:"Εισαγάγετε έναν νέο 6ψήφιο κωδικό πρόσβασης",
请确认两次密码输入一致:"Επιβεβαιώστε ότι οι δύο κωδικοί πρόσβασης που εισαγάγατε είναι συνεπείς",
修改登录密码:"Αλλαγή κωδικού πρόσβασης σύνδεσης",
密码长度:"Κωδικός πρόσβασης (6-12 χαρακτήρες)",
密码长度提示:"Εισαγάγετε 6-12 χαρακτήρες, συμπεριλαμβανομένων αριθμών ή γραμμάτων",
客服:"εξυπηρέτηση πελατών",
永续:"Βιώσιμος",
交割:"Διανομή",
永续合约:"Συμβόλαιο αορίστου χρόνου",
交割合约:"Συμβόλαιο παράδοσης",
全仓:"Πλήρης αποθήκη",
开多:"Ανοιχτό πολύ",
开空:"Ανοίξτε σύντομα",
价格:"τιμή",
开仓金额:"Ποσό ανοίγματος",
可用金额:"Διαθέσιμο ποσό",
合约金额:"Ποσό Συμβολαίου",
保证金:"περιθώριο",
手续费:"αμοιβή χειρισμού",
看涨:"αισιόδοξος",
看跌:"Bearish",
交割时间:"ώρα παράδοσης",
数量:"ποσότητα",
持有仓位:"Κρατήστε μια θέση",
当前委托:"Τρέχουσα παραγγελία",
历史订单:"Ιστορικές παραγγελίες",
暂无数据:"Χωρίς δεδομένα",
购买价:"τιμή αγοράς",
市价: "τιμή αγοράς",
限价: "όριο τιμής",
现价:"Τρέχουσα τιμή",
金额:"Ποσό",
盈亏:"Κέρδος και ζημία",
操作:"λειτουργεί",
平仓:"Κλείσιμο θέσης",
撤单:"Ακύρωση παραγγελίας",
方向:"κατεύθυνση",
剩余时间:"υπολειπόμενος χρόνος",
交割时间:"ώρα παράδοσης",
详情:"Λεπτομέριες",
名称:"όνομα",
最新价格:"τελευταία τιμή",
h24涨跌:"24ωρα σκαμπανεβάσματα",
h24涨跌幅:"24ωρη αύξηση και μείωση",
请输入开仓金额:"Εισαγάγετε το ποσό ανοίγματος",
请输入开仓价格:"Εισαγάγετε την τιμή ανοίγματος",
确定执行撤单操作:"Είστε βέβαιοι ότι θέλετε να ακυρώσετε την παραγγελία;",
确定执行平仓操作:"Είστε βέβαιοι ότι θα εκτελέσετε τη λειτουργία κλεισίματος θέσης;",
交割合约历史:"Ιστορικό συμβολαίου παράδοσης",
历史仓位:"Ιστορικές θέσεις",
到期时间:"Ημερομηνία λήξης",
闪兑:"Flash ανταλλαγή",
从:"από",
最大:"ανώτατο όριο",
可用数量:"Διαθέσιμη ποσότητα",
至:"προς την",
复制成功:"Αντιγράφηκε με επιτυχία",
基金理财:"Οικονομική διαχείριση ταμείου",
托管金额:"Ποσό μεσεγγύησης",
总收益:"Τα συνολικά έσοδα",
当日收益:"Το εισόδημα της ημέρας",
托管订单:"Διαταγή μεσεγγύησης",
规则:"κανόνας",
日收益:"Καθημερινό εισόδημα",
限额:"όριο",
周期:"κύκλος",
天:"ουρανός",
立即买入:"Αγορασε τωρα",
购买:"Αγορά",
购买日:"Ημερομηνία αγοράς",
起息日:"ημερομηνία αξίας",
派息时间:"Χρόνος πληρωμής μερίσματος",
每日:"καθημερινά",
计息结束日:"Ημερομηνία λήξης των δεδουλευμένων τόκων",
提前赎回:"πρόωρη λύτρωση",
预计收益:"Εκτιμώμενα έσοδα",
今日日收益:"Σήμερα (ημερήσιο εισόδημα)",
最少可投:"Ελάχιστη επένδυση",
最大可投:"Μέγιστη επένδυση",
请输入买入金额:"Εισαγάγετε το ποσό αγοράς",
可用金额:"Διαθέσιμο ποσό",
请输入买入金额:"Εισαγάγετε το ποσό αγοράς",
质押金额:"Ποσό ενεχύρου",
累计收益:"Σωρευτικό εισόδημα",
开始时间:"Ωρα έναρξης",
结束时间:"Τέλος χρόνου",
理财规则:"οικονομικούς κανόνες",
理财规则1:"Η οικονομική διαχείριση πραγματοποιείται με την ανάθεση του USD στην πλατφόρμα και η επαγγελματική ομάδα της πλατφόρμας διεξάγει οικονομικό αρμπιτράζ. Οι συμμετέχοντες μπορούν να αποκτήσουν μερίδιο από τα έσοδα οικονομικής διαχείρισης της πλατφόρμας κατά τη διάρκεια της περιόδου θεματοφυλακής.",
收益计算:"Υπολογισμός εσόδων",
理财规则2:"Ένα μέλος καταθέτει 10.000U στην πλατφόρμα και επιλέγει ένα χρηματοοικονομικό προϊόν με κύκλο 5 ημερών και ημερήσιο εισόδημα 0,3%~0,5%.Το ημερήσιο εισόδημα έχει ως εξής:",
最低:"χαμηλότερο",
最高:"Υψιστος",
理财规则3:"Και τα δύο: μπορείτε να το αποκτήσετε μετά από 5 ημέρες",
理财规则4:"Το εισόδημα διανέμεται καθημερινά. Το διανεμόμενο εισόδημα μπορεί να προσπελαστεί και να αποσυρθεί ανά πάσα στιγμή και να κατατεθεί στο κεφάλαιο. Μετά τη λήξη, θα επιστραφεί αυτόματα στον λογαριασμό σας.",
关于违约金:"Περί εκκαθαρισμένων ζημιών",
理财规则5:"Εάν επιθυμείτε να μεταφέρετε το κεφάλαιο που δεν έχει λήξει, θα προκληθούν εκκαθαρισμένες ζημιές.",
理财规则6:"Ρευστοποιημένες ζημιές = συντελεστής διακανονισμού x υπολειπόμενες ημέρες x ποσό επένδυσης.",
理财规则7:"Παράδειγμα: Η αναλογία εκκαθάρισης ζημιών αυτού του προϊόντος είναι",
剩余:"Παραμένων",
天到期投资:"Λήγει σε ημέρες και το ποσό της επένδυσης είναι",
则:"αλλά",
违约金:"ρευστοποιημένες ζημιές",
实际退还本金为:"Το πραγματικό κεφάλαιο που επιστράφηκε είναι",
现货账户:"spot λογαριασμό",
总资产:"Το σύνολο του ενεργητικού",
充币:"Κατάθεση νομισμάτων",
提币:"Αποσύρετε νομίσματα",
闪兑:"Flash ανταλλαγή",
投资组合:"χαρτοφυλάκιο",
冻结数量:"κατεψυγμένη ποσότητα",
帮助中心:"Κέντρο βοηθείας",
自选:"Προαιρετικός",
行情:"Εισαγωγικά",
资金:"κεφάλαια",
资讯:"Πληροφορίες",
我的:"δικος μου",
交易对:"ζεύγος συναλλαγών",
最新价:"Τελευταία τιμή",
成交量:"Ενταση ΗΧΟΥ",
标记价格:"τιμή σήμανσης",
h24最高价:"24 ώρες υψηλότερη τιμή",
h24最低价:"24 ώρες χαμηλότερη τιμή",
h24成交量:"Όγκος συναλλαγών 24 ώρες",
h24交易额:"Όγκος συναλλαγών 24 ώρες",
分时:"μοιράσμα χρόνου",
分1:"1 βαθμός",
分5:"5 βαθμοί",
分15:"15 βαθμοί",
分30:"30 βαθμοί",
小时1:"1 ώρα",
天1:"1 ημέρα",
周1:"1 εβδομάδα",
月1:"Ιανουάριος",
委托订单:"Σειρά",
最新交易:"Τελευταίες συναλλαγές",
买入:"Αγορά",
卖出:"Πουλώ",
时间:"χρόνος",
方向:"κατεύθυνση",
取消自选成功:"Ακύρωση επιλογής με επιτυχία",
添加成功:"Προστέθηκε με επιτυχία",
登录:"Σύνδεση",
账户:"λογαριασμός",
邮箱:"Ταχυδρομείο",
手机号:"Τηλεφωνικό νούμερο",
请输入账户:"Εισαγάγετε λογαριασμό",
请输入邮箱:"παρακαλώ εισάγετε το email σας",
请输入手机号:"Εισαγάγετε τον αριθμό τηλεφώνου",
密码:"Κωδικός πρόσβασης",
请输入密码:"Παρακαλούμε εισάγετε τον κωδικό πρόσβασης",
忘记密码:"ξεχάσετε τον κωδικό πρόσβασης;",
还没有账号:"Δεν υπάρχει λογαριασμός ακόμα",
去注册:"Πηγαίνετε για εγγραφή",
请输入登录账号:"Εισαγάγετε τον λογαριασμό σύνδεσής σας",
请输入登录密码:"Παρακαλώ εισάγετε τον κωδικό σας",
登录失败:"Η σύνδεση απέτυχε",
历史记录:"ιστορικό ρεκόρ",
充值:"ξεχειλίζω",
提现:"αποσύρω",
未审核:"Δεν έχει αναθεωρηθεί",
成功:"επιτυχία",
失败:"αποτυγχάνω",
快捷入口:"Γρήγορη είσοδος",
资金密码:"Κωδικός πρόσβασης ταμείου",
登录密码:"κωδικός σύνδεσης",
账变记录:"Αρχεία αλλαγής λογαριασμού",
邀请推广:"Πρόσκληση προώθησης",
通用:"Παγκόσμιος",
语言:"Γλώσσα",
在线客服:"ηλεκτρονική υπηρεσία",
身份认证:"Αυθεντικοποίηση",
高级认证:"Προηγμένη πιστοποίηση",
更多:"Περισσότερο",
帮助中心:"Κέντρο βοηθείας",
关于我们:"σχετικά με εμάς",
退出:"εγκαταλείπω",
已提交身份认证:"Έχετε υποβάλει τα στοιχεία ταυτότητάς σας και είναι υπό εξέταση",
您已完成身份认证:"Ολοκληρώσατε την επαλήθευση ταυτότητας",
您已完成高级认证:"Έχετε ολοκληρώσει την προηγμένη πιστοποίηση",
确定退出登录:"Είστε βέβαιοι ότι θέλετε να αποσυνδεθείτε;",
资讯:"Πληροφορίες",
公告:"ανακοίνωση",
状态:"κατάσταση",
已成交:"Η συμφωνία έγινε",
委托金额:"ποσό προμήθειας",
剩余金额:"ισορροπία",
订单类型:"Τύπος παραγγελίας",
市价委托:"παραγγελία της αγοράς",
限价委托:"οριακή σειρά",
订单号:"αριθμός παραγγελίας",
委托时间:"ώρα Επιτροπής",
U本位合约历史:"Ιστορικό συμβολαίου που βασίζεται σε U",
成交数量:"Ο αριθμός των συναλλαγών",
实现盈亏:"Πραγματοποιήστε κέρδη και ζημίες",
推广记录:"Ρεκόρ προώθησης",
我的总推广:"Η γενική μου προαγωγή",
总充值:"Ολική επαναφόρτιση",
一代人数:"Αριθμός γενεών",
二代人数:"Αριθμός δεύτερης γενιάς",
三代人数:"Αριθμός τριών γενεών",
立即推广:"Προώθηση τώρα",
我的推广:"η προαγωγή μου",
用户名:"όνομα χρήστη",
行情:"Εισαγωγικά",
加密货币:"κρυπτονόμισμα",
外汇:"Forex",
股票:"στοκ",
现货交易:"Spot Trading",
期货:"ἀεὶ ὁ θεὸς γεωμετρεῖ.",
热门:"Δημοφιλής",
涨幅榜:"Λίστα κερδισμένων",
跌幅榜:"Λίστα χαμένων",
快速充币:"Γρήγορη κατάθεση",
保存二维码:"Αποθήκευση κωδικού QR",
复制地址:"Αντιγραφή διεύθυνσης",
转出地址:"Διεύθυνση μεταφοράς (προαιρετικό)",
请输入转出地址:"Εισαγάγετε τη διεύθυνση μεταφοράς",
粘贴:"Επικόλληση",
充币数量:"Ποσό κατάθεσης",
请输入充币数量:"Εισαγάγετε το ποσό της κατάθεσης",
区块链网络:"Δίκτυο Blockchain",
付款凭证:"Κουπόνι πληρωμής (μεταφόρτωση στιγμιότυπου οθόνης των λεπτομερειών πληρωμής)",
请输入充值数量:"Εισαγάγετε το ποσό επαναφόρτισης",
充值通道:"Κανάλι επαναφόρτισης",
请选择充值币种:"Επιλέξτε το νόμισμα επαναφόρτισης",
官方充值通道:"Επίσημο κανάλι επαναφόρτισης",
设置密码:"Ορίστε κωδικό",
确认密码:"Επιβεβαίωση Κωδικού",
验证码:"Κωδικός επαλήθευσης",
请输入验证码:"εισάγετε τον κωδικό επαλήθευσης",
获取验证码:"λάβετε κωδικό επαλήθευσης",
重新发送:"Εκ νέου αποστολή",
邀请码:"Κωδικός πρόσκλησης",
请输入邀请码:"Εισαγάγετε τον κωδικό πρόσκλησης",
我已阅读并同意:"Έχω διαβάσει και συμφωνώ",
服务条款:"Όροι χρήσης",
注册:"κανω ΕΓΓΡΑΦΗ",
已有账号:"Εχετε ήδη λογαριασμό",
去登录:"Μεταβείτε στη σύνδεση",
请再次输入密码:"Εισαγάγετε ξανά τον κωδικό πρόσβασης",
请同意服务条款:"Παρακαλούμε συμφωνήστε με τους όρους παροχής υπηρεσιών",
注册失败:"η εγγραφή απέτυχε",
欢迎来到:"Καλωσήρθες στο",
全球最大的区块链资产平台:"Η μεγαλύτερη πλατφόρμα περιουσιακών στοιχείων blockchain στον κόσμο",
分享二维码:"Κοινή χρήση κωδικού QR",
链接分享:"Κοινή χρήση συνδέσμων",
复制:"αντίγραφο",
您的邀请码:"τον κωδικό πρόσκλησής σας",
到数字币地址:"Στη διεύθυνση ψηφιακού νομίσματος",
选择币种:"Επιλέξτε νόμισμα",
区块链网络:"Δίκτυο Blockchain",
提币说明:"Οδηγίες απόσυρσης",
提现费用:"Τέλη απόσυρσης",
可到账数量:"Διαθέσιμη ποσότητα",
可用:"Διαθέσιμος",
请输入支付密码:"Εισαγάγετε τον κωδικό πληρωμής",
请输入提币数量:"Εισαγάγετε το ποσό ανάληψης",
全部:"όλα",
支付密码:"Κωδικός πρόσβασης πληρωμής",
地址:"διεύθυνση",
委托价:"Τιμή παραγγελίας",
成交时间:"Χρόνος συναλλαγής",
成交金额:"Τζίρος",
委托中:"Με προμήθεια",
持仓中:"Στη θέση",
平仓中:"Κλείσιμο θέσης",
已平仓:"Η θέση έκλεισε",
开仓倍数:"Άνοιγμα πολλαπλών",
委托价格:"Τιμή προμήθειας",
收盘价:"Τιμή κλεισίματος",
收益率:"ποσοστό απόδοσης",
平仓时间:"Ωρα κλεισίματος",
请输入转换数量:"Εισαγάγετε την ποσότητα μετατροπής",
请上传付款凭证:"Ανεβάστε το κουπόνι πληρωμής",
开盘价:"τιμή ανοίγματος",
开市中:"Ανοιξε",
已休市:"Η αγορά έχει κλείσει",
美股:"μετοχές των ΗΠΑ",
平仓价:"Τιμή κλεισίματος",
到期结算完成:"Ο διακανονισμός λήξης ολοκληρώθηκε",
印度股票:"ινδικές μετοχές",
马来股票:"μετοχές της Μαλαισίας",
结算中:"Τακτοποίηση",
越南股票:"μετοχές του Βιετνάμ",
设置资金密码:"Ορισμός κωδικού πρόσβασης κεφαλαίου",
请输入资金密码:"Εισαγάγετε τον κωδικό πρόσβασης του ταμείου",
取消:"Ματαίωση",
确定:"Σίγουρος",
止损价:"Stop loss τιμή",
请输入止损价格:"Εισαγάγετε τιμή διακοπής απώλειας",
请输入止盈价格:"Εισαγάγετε την τιμή take profit",
止盈价:"Πάρτε την τιμή κέρδους",
设置止盈止损:"Ορίστε το κέρδος και τη διακοπή της ζημίας",
请输入关键词:"Εισαγάγετε μια λέξη-κλειδί",
搜索结果:"Αποτελέσματα αναζήτησης",
添加收款方式:"Προσθήκη τρόπου πληρωμής",
高级认证:"Προηγμένη πιστοποίηση",
历史委托:"ιστορική επιτροπή",
选择区域码:"Επιλέξτε κωδικό περιοχής",
请上传身份证图片:"Παρακαλούμε ανεβάστε μια φωτογραφία της ταυτότητάς σας",
请上传护照照片:"Ανεβάστε φωτογραφία διαβατηρίου",
请输入提币地址:"Εισαγάγετε τη διεύθυνση ανάληψης",
设置语言:"ρυθμίσεις γλώσσας",
最低金额: "Ελάχιστη ποσότητα",
购买金额: "τιμή αγοράς",
请输入要搜索的国家名称: "Εισαγάγετε το όνομα της χώρας που θέλετε να αναζητήσετε",
确定执行该操作: "Επιβεβαιώστε να το κάνετε αυτό?",
历史搜索: "Ιστορικές αναζητήσεις",
现货持仓: "Σημείο θέση",
永续持仓: "Αέναη θέση",
到期结算中: "Τακτοποίηση στην ωριμότητα",
火花图: "διάγραμμα σπινθήρα",
计价单位: "μονάδα πωλήσεων",
您拒绝了链接: "Απορρίψατε τον σύνδεσμο",
连接钱包成功: "Επιτυχής σύνδεση πορτοφολιού",
已断开钱包: "Το πορτοφόλι αποσυνδέθηκε",
钱包切换成功: "Επιτυχής αλλαγή πορτοφολιού",
请先安装钱包插件: "Εγκαταστήστε πρώτα την προσθήκη πορτοφολιού",
连接钱包: "Συνδέστε το πορτοφόλι",
交易: "εμπορικές συναλλαγές",
确认报价: "Επιβεβαιώστε την προσφορά",
您将获得: "θα πάρεις",
兑换自: "Εξαργύρωση από",
汇率: "συναλλαγματική ισοτιμία",
返回: "ΕΠΙΣΤΡΟΦΗ",
兑换: "ανταλλαγή",
消息: "πληροφορίες",
身份证反面照片: "Φωτογραφία της πίσω όψης της ταυτότητας",
身份证正面照片: "Μπροστινή φωτογραφία ταυτότητας",
手持身份证照片: "Φωτογραφία με ταυτότητα",
划转: "ΜΕΤΑΦΟΡΑ",
请输入划转数量: "Εισαγάγετε το ποσό μεταφοράς(USD)",
邀请链接: "Σύνδεσμος πρόσκλησης",
资料总览: "Επισκόπηση δεδομένων",
推广规则: "Κανόνες προώθησης",
总邀请人数: "Συνολικός αριθμός προσκεκλημένων",
总佣金: "συνολική προμήθεια",
安全绑定: "ασφαλές δέσιμο",
规则1: "1.Αυτή η διεύθυνση δέχεται μόνο {type}. Μην μεταφέρετε στοιχεία που δεν είναι {type} σε αυτήν τη διεύθυνση, διαφορετικά τα στοιχεία δεν θα ανακτηθούν.",
规则2: "2.Αφού επαναφορτίσετε την παραπάνω διεύθυνση, πρέπει να περιμένετε να επιβεβαιωθεί ο κόμβος δικτύου. Μόλις επιβεβαιωθεί ο κόμβος δικτύου, τα στοιχεία θα φτάσουν αυτόματα στον λογαριασμό σας. Θα σας ειδοποιήσουμε για την κατάσταση άφιξης με τη μορφή ανακοίνωσης ιστότοπου.",
规则3: "3.Η διεύθυνση επαναφόρτισής σας δεν θα αλλάζει συχνά και μπορείτε να επαναφορτίζετε επανειλημμένα. Εάν υπάρξει οποιαδήποτε αλλαγή, θα σας ειδοποιήσουμε μέσω ανακοίνωσης ιστότοπου",

安全中心: "Κέντρο ασφαλείας",
绑定手机号: "Σύνδεση αριθμού κινητού τηλεφώνου",
认证中心: "Κέντρο Πιστοποίησης",
身份认证: "Αυθεντικοποίηση",
认证要求: "Απαιτήσεις πιστοποίησης",
政府发行的证件: "Έγγραφα που εξέδωσε η κυβέρνηση",
功能与限制: "Χαρακτηριστικά και περιορισμοί",
无限额: "Κανένα όριο",
预计审核时间: "Εκτιμώμενος χρόνος ανασκόπησης: 60 λεπτά",
开始认证: "Έναρξη πιστοποίησης",
充币规则: "Κανόνες κατάθεσης",
套期保值: "Αντιστάθμιση κινδύνου, αντιστάθμιση κινδύνου",
登陆后继续: "Συνδεθείτε για να συνεχίσετε",
请选择充值方式: "Επιλέξτε τρόπο κατάθεσης",
请选择取款方式: "Επιλέξτε τρόπο ανάληψης",
客服充值: "Επαναφόρτιση εξυπηρέτησης πελατών",
    数字货币: "Ψηφιακό νόμισμα",
    银行取款: "Τραπεζική ανάληψη",
    请输入金额: "Εισαγάγετε το ποσό",
    银行名称: "Όνομα τράπεζας",
    银行卡号: "Αριθμός τραπεζικής κάρτας",
    请输入: "Παρακαλώ εισάγετε",
    请选择: "Παρακαλώ επιλέξτε",
    类型: "Τύπος",
    可用金额: "Διαθέσιμο ποσό",
    提款: "Ανάληψη"

    
}


// WEBPACK FOOTER //
// ./src/lang/gr.js